class AtelierDirectory extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.state = {
      city: '',
      service: '',
    }

    this.openId = ''
  }

  connectedCallback () {
    super.connectedCallback()

    this.atelierList = this.els.item.elements
    this.noResults = this.els['no-results'].element

    this.contents = this.els.content?.elements || []
    this.toggleButtons = this.els.button?.elements || []

    this.bindFilterSelects()
    this.bindAccordionEvents()
    this.bindOutsideClick()
  }

  bindFilterSelects () {
    this.selectContainers = this.els.select.elements

    this.selectContainers.forEach((container) => {
      const selectType = container.dataset.select
      const header = window.BAO.Utils.getElement(this.els.header.selector, {
        context: container,
      })
      const btn = window.BAO.Utils.getElement(this.els.selectbutton.selector, {
        context: container,
      })
      const selection = window.BAO.Utils.getElement(
        this.els.selection.selector,
        { context: container },
      )
      const options = window.BAO.Utils.getElements(this.els.option.selector, {
        context: container,
      })

      btn.addEventListener('click', () => {
        const expanded = header.getAttribute('aria-expanded') === 'true'
        if (!expanded) this.closeAllSelects(container)
        header.setAttribute('aria-expanded', String(!expanded))
        selection.hidden = expanded

        if (!expanded) {
          this.hideResultsDuringSelectOpen()
        } else {
          this.updateFilter()
        }
      })

      options.forEach((opt) => {
        opt.addEventListener('click', () => {
          const value = opt.dataset.value || opt.textContent.trim()

          const wasServiceEmpty = this.state.service === ''

          this.state[selectType] = value

          btn.textContent = value
          header.setAttribute('aria-expanded', 'false')
          selection.hidden = true

          if (selectType === 'city' && wasServiceEmpty) {
            const serviceContainer = this.selectContainers.find(
              (c) => c.dataset.select === 'service',
            )
            if (serviceContainer) {
              const serviceHeader = window.BAO.Utils.getElement(
                this.els.header.selector,
                { context: serviceContainer },
              )
              const serviceSelection = window.BAO.Utils.getElement(
                this.els.selection.selector,
                { context: serviceContainer },
              )

              this.closeAllSelects(serviceContainer)
              serviceHeader.setAttribute('aria-expanded', 'true')
              serviceSelection.hidden = false

              this.hideResultsDuringSelectOpen()
            }
          }

          this.els.selectbutton.elements.forEach((selectButtonEl) => {
            selectButtonEl.removeAttribute('aria-disabled')
          })

          this.updateFilter()
        })
      })
    })
  }

  closeAllSelects (except = null) {
    this.selectContainers.forEach((container) => {
      if (container === except) return
      const header = window.BAO.Utils.getElement(this.els.header.selector, {
        context: container,
      })
      const selection = window.BAO.Utils.getElement(
        this.els.selection.selector,
        { context: container },
      )
      header.setAttribute('aria-expanded', 'false')
      selection.hidden = true
    })
  }

  updateFilter () {
    let anyVisible = false

    this.atelierList.forEach((item) => {
      const cities = (item.dataset.city || '').split(',').filter(Boolean)
      const services = (item.dataset.service || '').split(',').filter(Boolean)

      const matchCity = !this.state.city || cities.includes(this.state.city)
      const matchService =
        !this.state.service || services.includes(this.state.service)

      if (matchCity && matchService) {
        item.style.display = ''
        anyVisible = true
      } else {
        item.style.display = 'none'
      }
    })

    if (this.state.city !== '' && this.state.service !== '') {
      if (anyVisible && this.state.city !== '' && this.state.service !== '') {
        this.els.items.element.setAttribute('aria-hidden', 'false')
        this.noResults.style.display = 'none'
      } else {
        this.els.items.element.setAttribute('aria-hidden', 'true')
        this.noResults.style.display = ''
      }
    }
  }

  hideResultsDuringSelectOpen () {
    this.els.items.element.setAttribute('aria-hidden', 'true')
    this.noResults.style.display = 'none'
  }

  bindOutsideClick () {
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeAllSelects()
      }
    })
  }

  bindAccordionEvents () {
    this.querySelectorAll('[data-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () =>
        this.handleAccordionToggle(toggle),
      )
    })
  }

  handleAccordionToggle (toggle) {
    const id = toggle.dataset.toggle
    const content = this.querySelector(`#content-${id}`)
    const isOpen = this.openId === id

    this.contents.forEach((c) => c.setAttribute('aria-hidden', 'true'))
    this.toggleButtons.forEach((t) => t.removeAttribute('aria-pressed'))

    if (isOpen) {
      this.openId = ''
      return
    }

    this.openId = id
    toggle.setAttribute('aria-pressed', 'true')
    content?.removeAttribute('aria-hidden')
  }
}

if (!customElements.get('atelier-directory')) {
  customElements.define('atelier-directory', AtelierDirectory)
}
